<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="90px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="租户类型" prop="tenantType">
            <el-select
              v-model="queryParams.tenantType"
              placeholder="请选择类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in typeOptions"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="租户名称" prop="tenantFullName">
            <el-input v-model="queryParams.tenantFullName" placeholder="请输入租户名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="联系人姓名" prop="linkNickName">
            <el-input v-model="queryParams.linkNickName" placeholder="请输入联系人姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="手机号" prop="linkTel">
            <el-input v-model="queryParams.linkTel" placeholder="请输入手机号" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="套餐" prop="packageId">
            <el-select
              v-model="queryParams.packageId"
              placeholder="请选择套餐"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in packageOptions"
                :key="dict.packageId"
                :label="dict.packageName"
                :value="dict.packageId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="9">
          <el-form-item label="启用时间" prop="validityStart">
            <el-date-picker
              v-model="queryParams.validityStart"
              type="daterange"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width:100%"
              @change="changeValidityStart"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="9">
          <el-form-item label="到期时间" prop="validityEnd">
            <el-date-picker
              v-model="queryParams.validityEnd"
              type="daterange"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width:100%"
              @change="changeValidityEnd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" @click="handleAdd">添加租户</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="租户类型" min-width="100" align="center" prop="tenantTypeDesc" fixed="left"/>
      <el-table-column label="租户名称" min-width="200" align="center" prop="tenantFullName" fixed="left"/>
      <el-table-column label="联系人姓名" min-width="140" align="center" prop="linkNickName" fixed="left"/>
      <el-table-column label="联系人手机号" min-width="120" align="center" prop="linkTel" />
      <el-table-column label="当前生效套餐" min-width="140" align="center" prop="packageName">
        <template slot-scope="scope">
          <el-button @click="goPackageDetail(scope.row)" type="text">{{scope.row.packageName}}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="单价（元）" min-width="100" align="center" prop="packageSinglePrice">
        <template slot-scope="scope">
          {{amountFormat(scope.row.packageSinglePrice)}}
        </template>
      </el-table-column>
      <el-table-column label="订购数量" min-width="100" align="center" prop="buyCount" />
      <el-table-column label="合计（元）" min-width="100" align="center" prop="packageTotalPrice">
        <template slot-scope="scope">
          {{amountFormat(scope.row.packageTotalPrice)}}
        </template>
      </el-table-column>
      <el-table-column label="启用时间" min-width="200" align="center" prop="validityStartTime" />
      <el-table-column label="到期时间" min-width="200" align="center" prop="validityEndTime" />
      <el-table-column label="当前账号数" min-width="100" align="center" prop="accountNum" />
      <el-table-column label="操作" min-width="150" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
    <AddTenantDialog ref="addTenantDialogRef" @success="getList"></AddTenantDialog>
  </div>
</template>

<script>
import { queryTenant, allSimpleList } from "@/api/saas/package";
import { amountFormat } from "@/utils/index";
import AddTenantDialog from "../components/addTenantDialog.vue";

export default {
  name: "BusinessList",
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      data: {
        startDate: "",
        endDate: ""
      },
      typeOptions: [{
        code: '1',
        name: '企业'
      },{
        code: '2',
        name: '组织'
      },{
        code: '3',
        name: '专家'
      }],
      packageOptions: [],
      total: 1,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        validityStartTime: "",
        validityEndTime: "",
        packageId: null,
        linkNickName: null,
        tenantFullName: null,
        linkTel: null
      },
      dataList: [
        {
          name: "一体化设备",
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          type: 2,
          typeDesc: "图文",
          status: 1,
          statusDesc: "已上线",
          updateTime: "2021.03.01 12:12:12"
        }
      ],
      amountFormat
    };
  },
  created() {
    this.queryList();
    this.allSimpleList();
  },
  components: {
    AddTenantDialog
  },
  methods: {
    // 跳转套餐详情
    goPackageDetail(row) {
      window.open("/saas/package/detail?packageId=" + row.packageId, "_blank")
    },
    // 跳转企业详情
    handleSee (row) {
      window.open("/saas/tenant/detail?id=" + row.tenantId, "_blank")
    },
    handleAdd() {
      this.$refs.addTenantDialogRef.open();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      // resetForm不生效
      this.queryParams.validityStartTimeStart = "";
      this.queryParams.validityStartTimeEnd = "";
      this.queryParams.validityEndTimeStart = "";
      this.queryParams.validityEndTimeEnd = "";
      this.queryParams.userId = null;
      this.handleQuery();
    },
    handleAddText() {
      this.$refs.addTextDialogRef.open();
    },
    getList() {
      this.queryParams.pageNum = 1;
      this.queryList();
    },
    queryList() {
      this.loading = true;
      queryTenant(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    allSimpleList() {
      allSimpleList().then(response => {
        this.packageOptions = response.data || [];
      });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    },
    // 启用时间
    changeValidityStart(e) {
      if (e) {
        this.queryParams.validityStartTimeStart = e[0];
        this.queryParams.validityStartTimeEnd = e[1];
      } else {
        this.queryParams.validityStartTimeStart = "";
        this.queryParams.validityStartTimeEnd = "";
      }
    },
    // 到期时间
    changeValidityEnd(e) {
      if (e) {
        this.queryParams.validityEndTimeStart = e[0];
        this.queryParams.validityEndTimeEnd = e[1];
      } else {
        this.queryParams.validityEndTimeStart = "";
        this.queryParams.validityEndTimeEnd = "";
      }
    }
  }
};
</script>
